import { FormDataGroup } from 'src/types';

export const PartialDataTestDriveConfigurador: Partial<FormDataGroup> = {
  headers: { DESC_FORMOBJECTIVE: 'Test Drive' },
  fields: {
    formFields: {},
    formularioFlag: 'testDrive',
    formName: 'lead-test_drive-configure',
    formType: 'testdrive',
    pageCategory: 'Test Drive',
  },
};
